import React from 'react';
import propTypes from 'prop-types';
import { CSVLink } from 'react-csv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'src/ui/mui-ui-kit';;
import { MuiDropdown, MuiDropdownItem } from '../mui-ui-kit';

const dropdownIcon = (
  <Button isColor="gradient-bright">
    <span>Download</span>
    <span className="icon">
      <FontAwesomeIcon icon={['fal', 'chevron-circle-down']} />
    </span>
  </Button>
);

/**
 *
 * @param data - array of objects
 * @param filename - string
 * @param headers - array of objects (optional, defaults to using object keys) -
 *    { label: 'Header', key: 'header' }
 * @returns {JSX.Element}
 * @constructor
 */
export const UiReportDownload = ({
  data,
  filename,
  headers: customHeaders,
}) => {
  const sanitizeData = data => {
    return data.map(entry => {
      const sanitizedEntry = {};
      // Use Object.keys() to get an array of the object's own property names
      Object.keys(entry).forEach(key => {
        let value = entry[key];
        // Check if value is a string and starts with one of the risky characters
        if (
          typeof value === 'string' &&
          ['=', '+', '-', '@'].includes(value.charAt(0))
        ) {
          // Prepend a single quote to the value
          value = `'${value}`;
        }
        sanitizedEntry[key] = value;
      });
      return sanitizedEntry;
    });
  };

  const isEmpty = !data || data.length === 0;
  const headers = customHeaders || isEmpty ? [] : Object.keys(data[0]);
  const sanitizedData = sanitizeData(data);
  return (
    <MuiDropdown isAlign="right" renderTrigger={dropdownIcon}>
        <MuiDropdownItem tag="div">
          <CSVLink
            filename={filename}
            disabled={isEmpty}
            className="report-download-dropdown-item"
            data={sanitizedData}
            headers={headers}
          >
            CSV
          </CSVLink>
        </MuiDropdownItem>
    </MuiDropdown>
  );
};

UiReportDownload.propTypes = {
  data: propTypes.arrayOf(propTypes.object).isRequired,
  filename: propTypes.string.isRequired,
  headers: propTypes.arrayOf(propTypes.object),
};

UiReportDownload.defaultProps = {
  headers: null,
};
